/**
 * Kewdale runs a primary and a secondary school on one campus. The staff screens' campus filter
 * offers them separately; everywhere else Kewdale is still one campus.
 *
 * The server knows the same two names (utils/campusSections.js there) and narrows the
 * re-enrolments list and its counts to the families with a child in those year groups.
 */
export const CAMPUS_SECTIONS = {
    'Kewdale Primary': { campus: 'Kewdale', years: [-1, 0, 1, 2, 3, 4, 5, 6] },
    'Kewdale Secondary': { campus: 'Kewdale', years: [7, 8, 9, 10, 11, 12] },
};

const sectionsOf = (campus) => Object.keys(CAMPUS_SECTIONS)
    .filter((name) => CAMPUS_SECTIONS[name].campus === campus);

/** The dropdown's choices: each campus as itself, except Kewdale, which becomes its two halves. */
export const withCampusSections = (campuses = []) => [
    ...new Set(campuses.flatMap((campus) => {
        const sections = sectionsOf(campus);
        return sections.length ? sections : [campus];
    })),
];

/** A year group as the roll labels it ("Kindy", "PP", "Year 7"), or as a number, to a number. */
export const yearFromLabel = (label) => {
    const text = String(label ?? '').trim();
    if (/^(kindy|kg)$/i.test(text)) return -1;
    if (/^(pp|pre-?primary)$/i.test(text)) return 0;
    const match = text.match(/^(?:year\s*|y)?(-?\d{1,2})$/i);
    return match ? Number(match[1]) : null;
};

/**
 * Whether a family belongs under the chosen campus filter. A section takes the families at its
 * campus with a child in one of its year groups, so a family with a child on each side is in both.
 */
export const familyInCampusChoice = (family = {}, choice = 'all') => {
    if (choice === 'all') return true;

    const section = CAMPUS_SECTIONS[choice];
    if (!section) return family.campus === choice;

    return family.campus === section.campus
        && (family.students || []).some((student) => section.years.includes(yearFromLabel(student.yearGroup)));
};
